import T from '@wojtekmaj/react-t';

import { Image, Wrapper } from './product_label.styles';

import veganIcon from '../../static/vegan.svg';

type ProductLabelProps = {
  children?: string;
  variant?:
    | 'contains_alcohol'
    | 'alcohol_free'
    | 'gluten_free'
    | 'lactose_free'
    | 'sugar_free'
    | 'vegan'
    | 'vegetarian'
    | (string & Record<never, never>);
};

export default function ProductLabel({ children, variant }: ProductLabelProps) {
  const icon = variant === 'vegan' ? veganIcon : null;

  const label = (() => {
    switch (variant) {
      case 'contains_alcohol':
        return 'with alcohol';
      case 'alcohol_free':
        return 'alcohol free';
      case 'gluten_free':
        return 'gluten free';
      case 'lactose_free':
        return 'lactose free';
      case 'sugar_free':
        return 'sugar free';
      case 'vegan':
        return 'vegan';
      case 'vegetarian':
        return 'vegetarian';
      default:
        return children;
    }
  })();

  return (
    <Wrapper variant={variant}>
      {icon ? <Image alt="" height={14} src={icon} width={14} /> : null}
      <T>{label}</T>
    </Wrapper>
  );
}
